import { render } from "./affiliate-sdg-view.vue?vue&type=template&id=13036711&scoped=true&ts=true"
import script from "./affiliate-sdg-view.vue?vue&type=script&lang=ts"
export * from "./affiliate-sdg-view.vue?vue&type=script&lang=ts"

import "./affiliate-sdg-view.vue?vue&type=style&index=0&id=13036711&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13036711"]])

export default __exports__